import { render, staticRenderFns } from "./bodyleft.vue?vue&type=template&id=842c9bd6"
import script from "./bodyleft.vue?vue&type=script&lang=js"
export * from "./bodyleft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports